import { render, staticRenderFns } from "./InwardGoodsForm.vue?vue&type=template&id=3ddbe820&"
import script from "./InwardGoodsForm.vue?vue&type=script&lang=js&"
export * from "./InwardGoodsForm.vue?vue&type=script&lang=js&"
import style0 from "./InwardGoodsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports